import { defineMessages } from 'react-intl';

const specialIntlMessages: { [key: string]: any } = defineMessages({
  1: { id: 'Personal Accident (Passengers & Driver)' },

  // Vehicle Type
  'Passenger Transportation': { id: 'Passenger Transportation' },
  'Pick-up': { id: 'Pickup' },
  Truck: { id: 'Truck' },
  Trailer: { id: 'Trailer' },
  Taxi: { id: 'Taxi' },
  '2 Wheeler <= 50CC': { id: '2 Wheeler <= 50CC' },
  '2 Wheeler > 50CC': { id: '2 Wheeler > 50CC' },
  '3Wheeler': { id: '3Wheeler' },
  'Electric Motorcycle': { id: 'Electric Motorcycle' },

  'Business use purpose': { id: 'Business use purpose' },
  'None business use purpose': { id: 'None-business use purpose' },
  'Special purpose vehicle with required load carrying capacity': {
    id: 'Special purpose vehicle with required load carrying capacity',
  },
  'Special purpose vehicle without required load carrying capacity': {
    id: 'Special purpose vehicle without required load carrying capacity',
  },
  'Pickup minivan': { id: 'Pickup, minivan' },
  'None business Pickup minivan': { id: 'None-business Pickup, minivan' },
  'Armored car': { id: 'Armored car' },
  Ambulance: { id: 'Ambulance' },
  'Special Vehicle': { id: 'Special Vehicle' },

  // Business Usage
  Yes: { id: 'Yes' },
  No: { id: 'No' },

  // Vehicle Origin
  'Made in Vietnam': { id: 'Made in Vietnam' },
  'Imported Car': { id: 'Imported Car' },

  // Destination
  SEA: { id: 'SEA' },
  Asia: { id: 'Asia' },
  Worldwide: { id: 'Worldwide' },

  // Policy Duration
  '3 Months': { id: '3 Months' },
  '6 Months': { id: '6 Months' },
  '12 Months': { id: '12 Months' },

  // Plan
  Individual: { id: 'Individual' },
  Family: { id: 'Family (Max. 4)' },
});

export default specialIntlMessages;
